import { CookieStorage } from 'cookie-storage';

const cookieStorage = new CookieStorage({
    path: '/',
    secure: location.protocol === "https:",
    sameSite: 'Strict'
});

class Provider {
    private token = ""

    public setAccessToken(token, remember) {
        this.token = token
        if (remember) {
            localStorage.setItem('user_portal_access_token', token)
        } else {
            const d = new Date()
            d.setTime(d.getTime() + (2 * 24 * 60 * 60 * 1000))
            cookieStorage.setItem('user_portal_access_token', token, {
                expires: d,
            })
        }
    }

    public getAccessToken() {
        if (this.token) {
            return this.token
        }

        let accessToken = localStorage.getItem('user_portal_access_token')
        if (!localStorage.getItem('user_portal_access_token')) {
            accessToken = cookieStorage.getItem('user_portal_access_token')
        }
        return accessToken
    }

    public deleteAccessToken() {
        this.token = ""
        localStorage.removeItem('user_portal_access_token')
        cookieStorage.removeItem('user_portal_access_token')
    }

    public getUserInfo() {
        const token = this.getAccessToken()
        const tokenParsed = this.parseJwt(token);
        if (tokenParsed && tokenParsed.meta_data && tokenParsed.meta_data) {
            const userInfo = JSON.parse(tokenParsed.meta_data.UserInfo)
            return userInfo
        }
        return null
    }

    public getUserId() {
        const userInfo = this.getUserInfo()
        if (userInfo) {
            return userInfo.user_id
        }
        return null
    }

    public getDomainId() {
        const userInfo = this.getUserInfo()
        if (userInfo) {
            return userInfo.domain_id
        }
        return null
    }

    public getLoginSession() {
        const token = this.getAccessToken()
        const tokenParsed = this.parseJwt(token);
        return JSON.parse(tokenParsed.meta_data.LoginSessionId)
    }

    public parseJwt(token) {
        try {
            const base64Url = token.split('.')[1]
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
            const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            }).join(''))
            return JSON.parse(jsonPayload)
        } catch (error) {
            return null
        }
    }

    public getDownloadToken() {
        const userInfo = this.getUserInfo()
        if (!userInfo) {
            return ""
        }
        return "5JckyXbswsTToNrYV4CRc1C4j9dqZCq8"
    }

}

export default new Provider()
